import { storyblokEditable } from '@storyblok/react';
import { motion } from 'framer-motion';
import Image from 'next/image';
import Link from 'next/link';
import { FC } from 'react';

import ButtonArrow, {
  ButtonDirection,
} from '@/components/elements/ButtonArrow';
import Container from '@/components/elements/Container';
import Heading from '@/components/elements/Heading';
import PreHeading from '@/components/elements/PreHeading';
import Section from '@/components/elements/Section';
import StandardText, {
  StandardTextSize,
} from '@/components/elements/StandardText';
import { storyblokLink } from '@/helpers/storyblokLink';

export interface StaffProps {
  blok: any;
}

const Staff: FC<StaffProps> = ({ blok }) => {
  const container = {
    hidden: {},
    show: {
      transition: {
        staggerChildren: 0.15,
        delayChildren: 0.15,
      },
    },
  };

  const item = {
    hidden: { opacity: 0, y: 25 },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        type: 'spring',
        stiffness: 75,
        mass: 0.75,
        duration: 0.35,
      },
    },
  };

  return (
    <Section {...storyblokEditable(blok)} className="overflow-hidden">
      <Container size={'wider'}>
        <StandardText blok={blok} size={StandardTextSize.MD} />
        <motion.div
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
          variants={container}
          className="mt-16 grid grid-cols-1 gap-8 xs:grid-cols-2 xs:gap-x-6 md:md:grid-cols-3 xl:grid-cols-4 xl:gap-x-10"
        >
          {blok.staff.map((s) => (
            <>
              {s.bio_page ? (
                <Link href={storyblokLink(s?.bio_page)} key={s._uid}>
                  <motion.div variants={item}>
                    <Image
                      {...s.photo}
                      alt={s.name}
                      src={s.photo.filename}
                      className="mb-4 w-full"
                      width={500}
                      height={700}
                    />
                    <Heading size="2xs" weight="semi">
                      {s.name}
                    </Heading>
                    <PreHeading
                      dot={true}
                      size="sm"
                      element="p"
                      color="lightgrey"
                      className="text-theme-grey"
                    >
                      {s.position}
                    </PreHeading>
                    <div className="flex text-theme-primary hover:text-theme-primary-hover">
                      View Bio{' '}
                      <ButtonArrow
                        direction={ButtonDirection.RIGHT}
                        className="ml-2 mt-[3px] h-[16px] fill-theme-primary"
                      />
                    </div>
                  </motion.div>
                </Link>
              ) : (
                <motion.div variants={item} key={s._uid}>
                  <Image
                    {...s.photo}
                    alt={s.name}
                    src={s.photo.filename}
                    className="mb-4 w-full"
                    width={500}
                    height={700}
                  />
                  <Heading size="2xs" weight="semi">
                    {s.name}
                  </Heading>
                  <PreHeading
                    dot={true}
                    size="sm"
                    element="p"
                    color="lightgrey"
                    className="text-theme-grey"
                  >
                    {s.position}
                  </PreHeading>
                </motion.div>
              )}
            </>
          ))}
        </motion.div>
      </Container>
    </Section>
  );
};

export default Staff;
